module.exports = __webpack_public_path__ + "media/images/screen-feed-f3bd15e8ab797b1c3845369e79662f78.png";